<template>
  <div v-if="hasLoaded" :class="`api-sport api-sport-${siteName}`">
    <component :is="comp" :competitionId="competitionId" :roundNum="roundNum"></component>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  defineAsyncComponent,
  ref,
  nextTick,
  inject,
} from "vue";
import { usecommonStore } from "~src/stores/CommonStore";

// this demonstrate dynamic frontend app using a single view
export default defineComponent({
  name: "result",
  setup() {
    const hasLoaded = ref(false);
    const componentName = ref("");
    const competitionId = ref<any>("");
    const roundNum = ref<any>("");
    const siteName = ref<any>("xoilacz");
    const myComponents: any = {
      Home: defineAsyncComponent(
        () =>
          import(
            /* webpackChunkName: 'Home' */
            "./Home.vue"
          )
      ),
    };

    const comp = computed(() => {
      // compare two objects
      return myComponents[componentName.value];
    });

    const commonStore = usecommonStore();

    return {
      comp,
      componentName,
      hasLoaded,
      competitionId,
      roundNum,
      siteName,
      commonStore
    };
  },
  mounted() {
    const that = this;

    // @ts-ignore
    if (that.$win.plugin_config_result) {
      that.doLoad();
      return;
    }

    document.onreadystatechange = async () => {
      if (document.readyState == "complete") {
        that.doLoad();
      }
    };
  },
  methods: {
    async doLoad() {
      const that = this;

      await nextTick();

      // @ts-ignore
      let viewComponent = that.$win.plugin_config_result.viewComponent;

      if (!viewComponent) {
        viewComponent = that.$route.query.comp;
      }

      if (!viewComponent) {
        viewComponent = "Home";
      }

      that.componentName = viewComponent;

      // @ts-ignore
      let competitionId = that.$win.plugin_config_result.competitionId;
      if (!competitionId) {
        competitionId = that.$route.query.competitionId;
      }
      this.competitionId = competitionId ? competitionId : '';

      // @ts-ignore
      let roundNum = that.$win.plugin_config_result.roundNum;
      if (!roundNum) {
        roundNum = that.$route.query.roundNum;
      }
      this.roundNum = roundNum ? roundNum : '';

      this.commonStore.setSportType('football');

      // @ts-ignore
      let siteName = that.$win.plugin_config_result.siteName;
      if (!siteName) {
        siteName = that.$route.query.siteName;
      }
      this.siteName = siteName ? siteName : "xoilacz";
      this.commonStore.setSiteName(this.siteName);

      // make sure data is loaded before ui render
      that.hasLoaded = true;
      that.$forceUpdate();
    },
  },
});
</script>

<style scoped></style>
